import { silentFetch } from './api';
import { getTelemetryPlatform } from './platform';

const DEVICE_ID_KEY = 'bg_device_id';

// Stable anonymous per-install id. Random UUID, never derived from anything —
// exists only so the backend can count distinct guest players.
export function getDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.() ||
        `g${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`);
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return null; // storage unavailable — skip telemetry rather than churn ids
  }
}

// Fire-and-forget: called when a signed-out player finishes a game.
export function recordGuestPlay(mode) {
  const deviceId = getDeviceId();
  if (!deviceId) return;
  silentFetch('/guest/plays', 'POST', {
    deviceId,
    mode,
    platform: getTelemetryPlatform(),
  });
}
